import { Trans } from '@lingui/macro'
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined'
import { Button } from '@mui/material'
import Inquiry from 'app/EgretLayout/SharedCompoents/Inquiry'
import { HELP_CASE_TYPES } from 'app/services/sfAuth/sfData/sfCaseTypes'
import { ButtonIcon } from 'app/views/common-components/ButtonIcon'
import React, { useState } from 'react'

type ButtonVariant = 'outlined' | 'contained' | 'text'

export const HelpButton: React.FC<{ caseType: string, variant?: ButtonVariant }> = ({ caseType, variant }) => {
  const [inquiryOpen, setInquiryOpen] = useState<boolean>(false)

  return (
    <>
      <Button
        color='primary'
        onClick={() => {
          setInquiryOpen(true)
        }}
        style={{ textTransform: 'none' }}
        variant={variant || (caseType === HELP_CASE_TYPES.CONTACT_US ? 'outlined' : 'contained')}
      >
        {caseType === HELP_CASE_TYPES.CONTACT_US ? <Trans>CONTACT US</Trans> : <Trans>HELP</Trans>}
        {caseType === HELP_CASE_TYPES.HELP &&
          <ButtonIcon small IconClass={HelpOutlineOutlinedIcon} />}
      </Button>
      <Inquiry
        selectCaseType={caseType === HELP_CASE_TYPES.CONTACT_US}
        open={inquiryOpen}
        handleClose={() => {
          setInquiryOpen(false)
        }}
        caseType={caseType}
      />
    </>
  )
}
